module.exports = __webpack_public_path__ + "img/52.53e776d5.jpg";